module.exports = "https://portperrypedals.ca/_res/img/pedals-cheque.bc322a0.jpg";